var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 280 40",
    style: {
      enableBackground: "new 0 0 280 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E6333F;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "86.3,1.1 80.1,12.9 73.8,1.1 70,1.1 78.7,15.5 78.7,25.7 80.1,25.7 81.4,25.7 81.4,15.5 90.1,1.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "96.3,22.9 96.3,14.9 106.7,14.9 106.7,13.4 106.7,11.9 96.3,11.9 96.3,3.9 107.4,3.9 108.7,1.1  93.3,1.1 93.3,13.4 93.3,25.7 108.7,25.7 107.4,22.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "247.5,14.9 257.9,14.9 257.9,13.4 257.9,11.9 247.5,11.9 247.5,3.9 258.6,3.9 260,1.1 244.6,1.1  244.6,13.4 244.6,25.7 247.5,25.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "174.4,20 163.5,1.1 163.5,25.5 166.4,25.5 166.4,12.3 174.4,25.5 182.4,12.3 182.4,25.5 185.3,25.5  185.3,1.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.2,4.5c0,0-2-4.1-7.8-4.1s-7.7,4.3-7.7,6.9s0.5,4.7,5.2,6.1s7.7,1.4,8.3,4.2s-1.7,5.1-5.2,5.1 c-2.5,0-4.8-1-6.5-2.8c-0.9,0.3-2.5,1.1-2.5,1.1c2,3,5.4,4.7,9,4.7c6.3,0,8.2-4.8,8.2-7.4s-0.9-5.5-6.4-6.6s-7.3-2.3-7.3-4.6 s2.1-4,5.1-4s5.5,2.6,5.5,2.6L211.2,4.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "271.3,1.1 262.6,1.1 264.1,4.1 269.9,4.1 269.9,25.7 271.3,25.7 272.7,25.7 272.7,4.1 278.5,4.1  280,1.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.3,1.1c-5.6,0-12.6,3.6-12.6,12.3s7,12.3,12.6,12.3s12.6-3.6,12.6-12.3S152.9,1.1,147.3,1.1z M147.3,23.4 c-3.5,0-9.6-2-9.6-10s6.1-10,9.6-10s9.6,2.1,9.6,10S150.8,23.4,147.3,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.3,1.1c-5.6,0-12.6,3.6-12.6,12.3s7,12.3,12.6,12.3s12.6-3.6,12.6-12.3S234.9,1.1,229.3,1.1z M229.3,23.4 c-3.5,0-9.6-2-9.6-10s6.1-10,9.6-10s9.6,2.1,9.6,10S232.8,23.4,229.3,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131,20c-1.9,2.1-4.6,3.3-7.4,3.3c-3.5,0-9.6-2-9.6-10s6.2-10,9.6-10c2.8,0,5.5,1.2,7.4,3.3l1.4-2.3 C130,2.1,126.8,1,123.6,1C118,1,111,4.6,111,13.3s7,12.3,12.6,12.3c3.2,0,6.4-1.1,8.8-3.3L131,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.2,11l5-3.6l-8.9-6.5l-1.9,5.8L31.2,11z M34.2,7.4l-3,2.2l-4.5-3.3l1.2-3.6L34.2,7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.3,19.1h6.1L37.1,8.7l-5,3.6L34.3,19.1z M35.2,18l-1.7-5.3l3-2.2l2.5,7.5H35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.1,27.6l5,3.6l3.4-10.4h-6.2L32.1,27.6z M38.9,21.9l-2.4,7.5l-3-2.2l1.7-5.3H38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.4,33.1l1.9,5.9l8.9-6.5l-5-3.6L25.4,33.1z M27.9,37.1l-1.2-3.6l4.5-3.2l3,2.2L27.9,37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.7,33.6l-1.9,5.8h11l-1.9-5.8H16.7z M16.3,38.3l1.2-3.6H23l1.2,3.6H16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,28.9L9.4,28.9l-5.1,3.6l8.9,6.5l1.9-5.8L9.4,28.9z M6.3,32.5l3-2.2l4.5,3.2l-1.2,3.6L6.3,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.1,20.8H0l3.4,10.4l5-3.6L6.1,20.8z M5.3,21.9L7,27.1l-3,2.2l-2.4-7.5H5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.4,12.3l-5-3.6L0,19.1h6.1L8.4,12.3z M1.6,18L4,10.5l3,2.2L5.3,18H1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.1,6.8l-1.9-5.8L4.3,7.4l5,3.6L15.1,6.8z M12.6,2.8l1.2,3.6L9.3,9.6l-3-2.2L12.6,2.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "23.8,6.2 25.7,0.4 14.8,0.4 16.7,6.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.6,
    className: "st0",
    width: 0.8,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.2,39.7l2.6-6.7h0.7l2.6,6.7h-0.7l-0.8-2.1h-3l-0.8,2.1L77.2,39.7z M78.9,37h2.6l-1.3-3.5L78.9,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88,39.7V33h0.6v6.1h3.6v0.5L88,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.1,39.7V33h0.6v6.1h3.6v0.5L97.1,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.7,39.7V33h0.6v6.1h3.6v0.5L112.7,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.1,39.7V33h0.6v6.7L122.1,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.8,33h0.7l2,5.9l2-5.9h0.7l-2.3,6.7h-0.7L127.8,33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.2,39.7V33h0.6v6.7L138.2,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.1,33.8L145.1,33.8v5.8h-0.6V33h0.7l3.9,5.8l0,0V33h0.6v6.7H149L145.1,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158,36.7v-0.5h2.9v3.5h-0.5v-1.2c-0.1,0.2-0.3,0.4-0.4,0.5c-0.2,0.2-0.3,0.3-0.5,0.4 c-0.2,0.1-0.4,0.2-0.7,0.3c-0.3,0.1-0.6,0.1-0.9,0.1c-0.4,0-0.8-0.1-1.2-0.2c-0.4-0.1-0.7-0.4-0.9-0.7c-0.3-0.3-0.5-0.7-0.6-1.1 c-0.2-0.5-0.2-1-0.2-1.6c0-0.5,0.1-0.9,0.2-1.4c0.1-0.4,0.3-0.8,0.6-1.1c0.3-0.3,0.6-0.6,1-0.7c0.4-0.2,0.9-0.3,1.3-0.3 c0.3,0,0.7,0,1,0.1c0.3,0.1,0.6,0.2,0.8,0.4c0.2,0.2,0.5,0.4,0.6,0.7c0.2,0.3,0.3,0.6,0.4,0.9h-0.6c-0.1-0.2-0.2-0.5-0.3-0.7 c-0.1-0.2-0.3-0.4-0.5-0.5c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.5-0.1-0.7-0.1c-0.4,0-0.8,0.1-1.1,0.2c-0.3,0.2-0.6,0.4-0.8,0.7 c-0.2,0.3-0.4,0.6-0.4,1c-0.1,0.4-0.1,0.9-0.1,1.3c0,0.4,0.1,0.7,0.2,1.1c0.1,0.3,0.3,0.6,0.5,0.9c0.2,0.3,0.5,0.5,0.8,0.6 c0.3,0.1,0.7,0.2,1,0.2c0.2,0,0.4,0,0.6-0.1c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.4-0.2,0.5-0.4c0.2-0.2,0.3-0.3,0.4-0.5 c0.1-0.2,0.2-0.4,0.2-0.7c0-0.2,0.1-0.5,0.1-0.7L158,36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.1,39.7V33h0.6v6.7L173.1,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180,33.8L180,33.8v5.8h-0.6V33h0.7l3.9,5.8l0,0V33h0.6v6.7h-0.7L180,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.6,39.7V33h0.6v2.9h3.9V33h0.6v6.7h-0.6v-3.3h-3.9v3.3H196.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.6,39.7l2.6-6.7h0.7l2.6,6.7h-0.6l-0.8-2.1h-3l-0.8,2.1L206.6,39.7z M208.2,37h2.6l-1.3-3.5L208.2,37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M218,36.6v3h-0.6V33h2.6c0.6,0,1.2,0.1,1.7,0.4c0.4,0.3,0.6,0.8,0.6,1.3c0,0.4-0.1,0.7-0.3,1 c-0.2,0.3-0.5,0.5-0.8,0.6c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0.1,0.2,0.3,0.2,0.5c0.1,0.2,0.1,0.3,0.1,0.5c0,0.2,0,0.4,0,0.5 c0,0.2,0,0.4,0,0.6c0,0.1,0,0.3,0.1,0.4c0,0.1,0,0.2,0.1,0.2c0,0.1,0.1,0.1,0.1,0.1v0.1h-0.7c-0.1-0.1-0.1-0.3-0.1-0.5 c0-0.2,0-0.4-0.1-0.6s0-0.4,0-0.6c0-0.2,0-0.3-0.1-0.5c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.1 h-0.4L218,36.6z M220,36.1c0.2,0,0.4,0,0.6-0.1c0.2,0,0.4-0.1,0.5-0.2c0.1-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.4,0.1-0.6 c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4,0-0.6,0h-2v2.6L220,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M227.4,39.7V33h1l2.2,5.9l0,0l2.1-5.9h1v6.7h-0.6v-6l0,0l-2.2,6h-0.6l-2.2-6l0,0v6L227.4,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.9,36.3c0-0.5,0.1-0.9,0.2-1.4c0.1-0.4,0.3-0.8,0.6-1.1c0.3-0.3,0.6-0.6,1-0.8c0.4-0.2,0.9-0.3,1.3-0.3 c0.5,0,0.9,0.1,1.4,0.3c0.4,0.2,0.7,0.4,1,0.8c0.3,0.4,0.4,0.7,0.5,1.2c0.1,0.4,0.2,0.9,0.2,1.4c0,0.5-0.1,0.9-0.2,1.4 c-0.1,0.4-0.3,0.8-0.6,1.1c-0.3,0.3-0.6,0.6-1,0.8c-0.9,0.4-1.8,0.4-2.7,0c-0.4-0.2-0.7-0.4-1-0.8c-0.3-0.3-0.5-0.7-0.6-1.1 C238.9,37.3,238.9,36.8,238.9,36.3z M242,39.3c0.4,0,0.8-0.1,1.1-0.2c0.3-0.2,0.6-0.4,0.8-0.7c0.2-0.3,0.4-0.6,0.4-0.9 c0.1-0.4,0.1-0.7,0.1-1.1c0-0.4-0.1-0.8-0.2-1.2c-0.1-0.3-0.3-0.7-0.5-0.9c-0.2-0.3-0.5-0.5-0.8-0.6c-0.3-0.1-0.7-0.2-1-0.2 c-0.4,0-0.8,0.1-1.1,0.2c-0.3,0.2-0.6,0.4-0.8,0.7c-0.2,0.3-0.4,0.6-0.4,1c-0.2,0.7-0.2,1.5,0,2.3c0.1,0.3,0.2,0.7,0.4,0.9 c0.2,0.3,0.5,0.5,0.8,0.7C241.3,39.3,241.6,39.3,242,39.3L242,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250.9,33.8L250.9,33.8v5.8h-0.6V33h0.7l3.9,5.8l0,0V33h0.6v6.7h-0.7L250.9,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263,36.2l2-3.2h0.7l-2.4,3.8v2.9h-0.6v-2.9l-2.4-3.8h0.7L263,36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M271,35.1V33h0.7v2.1l-0.1,2.9h-0.4L271,35.1z M271,39.7v-0.8h0.7v0.8H271z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2b80863f2a13290d2e5c01920697a168.svg";
export { ForwardRef as ReactComponent };